// extracted by mini-css-extract-plugin
export default {"urlColumn":"ExternalModerationPhaseRow-urlColumn-6baedf9a095c65a4f6a38ea17f3cb8c8","detailsButton":"ExternalModerationPhaseRow-detailsButton-35522e030af7b04b080fcdfa52d9c4ce"};